import { render, staticRenderFns } from "./alerttwo.vue?vue&type=template&id=7f243d6c&scoped=true&"
import script from "./alerttwo.vue?vue&type=script&lang=js&"
export * from "./alerttwo.vue?vue&type=script&lang=js&"
import style0 from "./alerttwo.vue?vue&type=style&index=0&id=7f243d6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f243d6c",
  null
  
)

export default component.exports